module.exports = __webpack_public_path__ + "media/images/patterns/2-485c55ca5d3bda32a325f12a6a95b0a0.png";